import React, { useEffect, useRef, useState } from 'react';
import Header from './components/header';
import Footer from './components/footer';
import { timelineData, timelineDataSecond, sliderDataMobile } from './components/data';
import SEOTags from './common/SEO';
import Carousel from "react-material-ui-carousel";

const Timeline = () => {
  const scrollContainerRef = useRef(null);
  const [isHorizontalScrollActive, setIsHorizontalScrollActive] = useState(true);


    useEffect(() => {
        SEOTags(
            "Timeline | Freddie Figgers",
            "Freddie Figgers, born in Quincy, Florida, is an entrepreneur, and philanthropist dedicated to innovation, community support, and technology solutions.",
            "Timeline, Freddie Figgers"
        );
      const container = scrollContainerRef.current;
      if (!container) return;
  
      const handleWheelScroll = (event) => {
        // If the user provides native horizontal input, let it work natively.
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          // Let the browser handle native horizontal scroll.
          return;
        }
        
        // Otherwise, we have a predominantly vertical scroll input.
        // Check the direction.
        const scrollingDown = event.deltaY > 0;
        const scrollingUp = event.deltaY < 0;
  
        if (isHorizontalScrollActive) {
          // Prevent default vertical scrolling behavior.
          event.preventDefault();
          container.scrollLeft += event.deltaY; // Map vertical wheel to horizontal scroll
  
          // When we reach the right edge, disable horizontal scrolling logic.
          if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
            setIsHorizontalScrollActive(false);
          }
        } else {
          // At the right edge: allow vertical scroll if going down.
          if (scrollingDown) return;
  
          // When scrolling up, still map it until reaching the left edge.
          if (scrollingUp && container.scrollLeft > 0) {
            event.preventDefault();
            container.scrollLeft += event.deltaY;
          }
  
          if (container.scrollLeft <= 0) {
            setIsHorizontalScrollActive(true);
          }
        }
      };
  
      container.addEventListener("wheel", handleWheelScroll, { passive: false });
      return () => {
        container.removeEventListener("wheel", handleWheelScroll);
      };
    }, [isHorizontalScrollActive]);

  return (
    <>
      <Header />
      <div className="layout_container">
        {window.isMobile ? (
          <>
            <div className='timeline_container'>
              <Carousel autoPlay={true} navButtonsAlwaysVisible style={{ marginBottom: '20px', height: '400px' }}>
                {sliderDataMobile.map((post, index) => (
                  <div key={index} className='post-slider'>
                    <h3>{post.year}</h3>
                    <div className='content' dangerouslySetInnerHTML={{ __html: post.content }}></div>
                    <img src={post.image} style={{ maxWidth: post.imageWidth ? post.imageWidth : '' }} alt="" />
                  </div>
                ))}
              </Carousel>
            </div>
            <br />
          </>
        ) : (
          <div className="horizontal-scroll-container" ref={scrollContainerRef}>
            <div className="horizontal_content" style={{ paddingBottom: 0 }}>
              {timelineData.map((post, index) => (
                <div key={index} className="post-card" style={{ maxWidth: post.width ? post.width : '' }}>
                  <h3>{post.year}</h3>
                  <div className='content' dangerouslySetInnerHTML={{ __html: post.content }}></div>
                  <img src={post.image} style={{ maxWidth: post.imageWidth ? post.imageWidth : '' }} alt="" />
                </div>
              ))}
            </div>

            <div className='gredient_border'>
              <div className='gredient_border_middle'></div>
            </div>

            <div className="horizontal_content" style={{ paddingTop: 0, alignItems: 'flex-start' }}>
              {timelineDataSecond.map((post, index) => (
                <div key={index} style={{ maxWidth: post.width ? post.width : post.sizeBig ? '590px' : '' }} className="post-card">
                  <h3>{post.year}</h3>
                  <div className='content' dangerouslySetInnerHTML={{ __html: post.content }}></div>
                  <img src={post.image} alt="" />
                </div>
              ))}
            </div>
          </div>
        )}

        {window.isMobile ? (
          <>
            <br />
            <div className='timeline_container'>
              <Carousel autoPlay={true} navButtonsAlwaysVisible>
                {/* Additional mobile carousel content */}
              </Carousel>
            </div>
          </>
        ) : (
          <div className="horizontal-scroll-container">
            {/* You can place any additional desktop content here */}
          </div>
        )}
      </div>
       <Footer /> 
    </>
  );
};

export default Timeline;
